/*
 * @Description: 网络配置常量
 */

export enum InfoShowType{
     LOG,
     NOTIFICATION,
     TOAST
 }
